import clickOutside from 'v-click-outside';
import scrollSpy from './v-scrollspy';
import longPress from './v-longpress';
import mask from './v-mask';

Vue.directive('click-outside', clickOutside.directive);
Vue.directive('scroll-spy', scrollSpy);
Vue.directive('longpress', longPress);
Vue.directive('mask', mask);
